import {MP4Box} from "./mp4box.all.min.js";

class WebSocketWithPause extends WebSocket {
  constructor(url) {
    super(url);
    this.isPaused = false;
    this.queue = [];
  }

  pause() {
    this.isPaused = true;
  }

  send(data) {
    if (this.isPaused) {
      this.queue.push(data);
    } else {
      super.send(data);
    }
  }
}
export class VideoPlayerWithWebSocket {
  constructor(videoElement, websocketUrl) {
    this.prePos = 0;
    this.loadData = {
      video: [],
      audio: []
    };
    this.codecs = [];
    this.first = true;
    this.second = false;
    this.haveAudio = false;
    this.baseUrl = websocketUrl;
    this.sourceBuffer;
    this.sourceBufferAudio;
    this.video = videoElement;
    this.ws = new WebSocketWithPause(this.baseUrl);
    this.ws.binaryType = 'arraybuffer';
    this.isPlaying = false;
    this.ws.onmessage = (e) => this.handleWebSocketMessage(e);
    this.mediaSource = new MediaSource();
    this.video.src = window.URL.createObjectURL(this.mediaSource);
    this.mediaSource.addEventListener('sourceopen', () => this.onMediaSourceOpen());
    if (!window.MediaSource) {
      console.error('No Media Source API available');
    }
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
  }

  //Обработчик события открытия медиа-источника
  onMediaSourceOpen() {
    // Установка начальных параметров при открытии медиа-источника
    this.video.buffered.start = 0;
    this.video.currentTime = 0;
  }

  //Обработчик события при получении сообщения от WebSocket
  handleWebSocketMessage(e) {
    //Обработка сообщений от WebSocket, демультиплексия видео и аудио
    if (this.first) {
      this.getCodecsStream(e.data);
      let mimeCodec;
      let view = new Uint8Array(e.data);
      let needed = new Uint8Array([3]);
      if (this.isArraysEqual(view.slice(143, 144), needed)) {
        this.flags = true;
        mimeCodec = `video/mp4; codecs="${this.codecs.join(', ')}"`;
        this.second = false;
      } else {
        this.flags = false;
        mimeCodec = `video/mp4; codecs="${this.codecs[0]}"`;
        this.second = true;
      }
      this.sourceBuffer = this.mediaSource.addSourceBuffer(mimeCodec);
      this.sourceBuffer.mode = "sequence";
      this.loadData["video"].push(e.data);
      this.first = false;
      if (this.video.autoplay) {
        this.ws.send("play");
      }
      return;
    } else {
      if (this.second) {
        let view = new Uint8Array(e.data);
        let needed = new Uint8Array([102, 116, 121, 112]);
        if (this.isArraysEqual(view.slice(4, 8), needed)) {
          this.getCodecsStream(e.data);
          let mimeCodecAudio = `audio/mp4; codecs="${this.codecs[1]}"`;
          this.sourceBufferAudio = this.mediaSource.addSourceBuffer(mimeCodecAudio);
          this.sourceBufferAudio.mode = "sequence";
          this.loadData["audio"].push(e.data);
          this.second = false;
          this.haveAudio = true;
          return;
        }
        this.second = false;
      }

      let view = new Uint8Array(e.data);
      if (this.flags) {
        this.loadData["video"].push(view.buffer);
      } else {
        if (view[47] === 1) {
          this.loadData["video"].push(view.buffer);
        } else if (view[47] === 2) {
          this.loadData["audio"].push(view.buffer);
        }
      }

      for (let type in this.loadData) {
        if (type === "video" && this.loadData[type].length >= 1) {
          if (!this.sourceBuffer || this.sourceBuffer.updating) {
            continue;
          }
          if (this.loadData[type].length === 1) {
            this.sourceBuffer.appendBuffer(this.loadData[type].shift());
            continue;
          }
          let byteLength = this.loadData[type].reduce((acc, qnode) => acc + qnode.byteLength, 0);
          let mp4buf = new Uint8Array(byteLength);
          let offset = 0;
          this.loadData[type].forEach(qnode => {
            let frame = new Uint8Array(qnode);
            mp4buf.set(frame, offset);
            offset += qnode.byteLength;
          });
          this.sourceBuffer.appendBuffer(mp4buf);
          this.loadData[type].splice(0, this.loadData[type].length);
        }
        if (type === "audio" && this.loadData[type].length >= 1) {
          if (!this.sourceBufferAudio || this.sourceBufferAudio.updating) {
            continue;
          }
          if (this.loadData[type].length === 1) {
            this.sourceBufferAudio.appendBuffer(this.loadData[type].shift());
            continue;
          }
          let byteLength = this.loadData[type].reduce((acc, qnode) => acc + qnode.byteLength, 0);
          let mp4buf = new Uint8Array(byteLength);
          let offset = 0;
          this.loadData[type].forEach(qnode => {
            let frame = new Uint8Array(qnode);
            mp4buf.set(frame, offset);
            offset += qnode.byteLength;
          });
          this.sourceBufferAudio.appendBuffer(mp4buf);
          this.loadData[type].splice(0, this.loadData[type].length);
        }
      }
    }
    this.sourceBuffer.onupdateend = (e) => {
      let pos = this.video.currentTime;
      if (this.video.buffered.length > 0) {
        let start = this.video.buffered.start(this.video.buffered.length - 1);
        let end = this.video.buffered.end(this.video.buffered.length - 1);
        if (pos < start) {
          this.video.currentTime = start;
        }
        if (pos > end) {
          this.video.currentTime = start;
        }
        if (pos - this.prePos !== 0 && end - pos > 1) {
          this.video.currentTime = end;
        }
        for (let i = 0; i < this.video.buffered.length - 1; i++) {
          let prestart = this.video.buffered.start(i);
          let preend = this.video.buffered.end(i);
          if (!this.sourceBuffer.updating) {
            this.sourceBuffer.remove(prestart, preend);
            if (this.haveAudio && !this.sourceBufferAudio.updating) {
              this.sourceBufferAudio.remove(prestart, preend);
            }
          }
        }
        if (pos - start > 10 && !this.sourceBuffer.updating) {
          this.sourceBuffer.remove(0, pos - 3);
          if (this.haveAudio && !this.sourceBufferAudio.updating) {
            this.sourceBufferAudio.remove(0, pos - 3);
          }
        }
        if (end - pos > 10 && !this.sourceBuffer.updating) {
          this.sourceBuffer.remove(0, end - 3);
          if (this.haveAudio && !this.sourceBufferAudio.updating) {
            this.sourceBufferAudio.remove(0, end - 3);
          }
          if (!this.isPlaying) {
            return;
          }
        }

        this.prePos = pos;
      }
    };
  }

  play() {
    if (this.video.paused && !this.isPlaying) {
      this.video.play().then(() => {
        this.isPlaying = true;
        if (this.mediaSource.readyState === 'ended') {
          this.mediaSource.readyState = 'open';
        }
        // Возобновление получения данных по веб-сокету при воспроизведении
        this.ws.send("play"); // Отправляем сообщение "play" через WebSocket
      }).catch(error => console.error('Error playing video:', error));
    } else {
      this.ws.send("play");
    }
  }

  pause() {
    if (!this.video.paused && this.isPlaying) {
      this.video.pause();
      this.isPlaying = false;
      this.ws.send("pause");
    } else {
      this.ws.send("pause");
    }
  }
  //Метод завершения работы и закрытия WebSocket
  destroy() {
    this.ws.close();
  }
  //Вспомогательная функция для сравнения массивов
  isArraysEqual(firstArray, secondArray) {
    return firstArray.toString() === secondArray.toString();
  }
  //Демуксинг MOOV-блока для получения информации о кодеках
  demuxMoov(info) {
    for (const track of info.tracks) {
      this.codecs.push(track.codec);
    }
  }
  //Получение кодеков из потока данных
  getCodecsStream(data) {
    const moov = data;
    const mp4Box = new MP4Box();
    mp4Box.onReady = (info) => this.demuxMoov(info);
    moov.fileStart = 0;
    mp4Box.appendBuffer(moov);
  }
}
